function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Linkify from 'react-linkify';
import Box from './Box';
const handleNl2br = function (str) {
  let doubleSpaced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return str.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').map((textLine, key) => /*#__PURE__*/React.createElement("span", {
    key: key
  }, textLine, doubleSpaced ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)) : /*#__PURE__*/React.createElement("br", null)));
};
export const Text = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
    doubleSpaced,
    nl2br,
    linkify,
    children,
    ...otherProps
  } = props;
  if (nl2br && linkify) {
    children = /*#__PURE__*/React.createElement(Linkify, null, handleNl2br(children, doubleSpaced));
  } else if (nl2br) {
    children = /*#__PURE__*/React.createElement(React.Fragment, null, handleNl2br(children, doubleSpaced));
  } else if (linkify) {
    children = /*#__PURE__*/React.createElement(Linkify, null, children);
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    tx: "text"
  }, otherProps, {
    children: children
  }));
});
Text.displayName = 'Text';
export default Text;